// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_AT_RULE_IMPORT_0___ = require("-!../../node_modules/css-loader/dist/cjs.js??ref--6-oneOf-1-1!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/loaders/stylePostLoader.js!../../node_modules/postcss-loader/src/index.js??ref--6-oneOf-1-2!../assets/css/global.css");
exports = ___CSS_LOADER_API_IMPORT___(false);
exports.i(___CSS_LOADER_AT_RULE_IMPORT_0___);
// Module
exports.push([module.id, "\n.custom-row-table[data-v-5a22f828] {\n  background-color: #fff;\n  padding: 12px 0px 2px 0px;\n  margin: 40px 0px 20px 0px;\n  border-radius: 12px;\n  overflow: hidden;\n}\n", ""]);
// Exports
module.exports = exports;
